/**
 * Created by Administrador on 11/10/2016.
 */
(function(){
    'use strict';

    var numbersOnly = {
        template: '',
        controller: numbersOnlyController,
        controllerAs: 'vm',
        bindings: {
            errorKey: "@",
            formName: '<'
        }
    };

    angular
        .module('completeAir')
        .component('numbersOnly', numbersOnly);

    function numbersOnlyController(){
        var vm = this;

        vm.$onInit = function () {
            vm.ngModelCtrl = vm.formName;
            //vm.$postLink();
        }

        vm.$postLink = function() {
            if (vm.ngModelCtrl !== undefined) {
              vm.ngModelCtrl.$parsers.push(function (inputValue) {

                if (inputValue == undefined) return '';

                inputValue = inputValue.toString();
                var transformedInput = inputValue.replace(/[^0-9]/g, '');
                if (transformedInput !== inputValue) {
                  vm.ngModelCtrl.$setViewValue(transformedInput);
                  vm.ngModelCtrl.$render();
                }
                return transformedInput;
              });
            }
        }
    }

})();
